import { translate } from '@utils/i18n';
import { NAMESPACE, parseOptionsString } from './fieldDefinitionsUtils';
const TRANSLATED_OPTIONS_KEYS = ['optionsFr', 'optionsEs'];
export function hasUnpairedTranslatedOptions(field) {
    const options = field.options || [];
    if (options.length === 0)
        return false;
    return TRANSLATED_OPTIONS_KEYS.some((key) => {
        const translated = field[key] || [];
        return translated.length > 0 && translated.length !== options.length;
    });
}
/**
 * Validates a default value against field type and options
 * @param value - The default value to validate
 * @param fieldType - The type of the field (text, number, select, multiselect, etc.)
 * @param options - Array of valid options (for select/multiselect fields)
 * @returns Error message string if validation fails, empty string if valid
 */
export function validateDefaultValue(value, fieldType, options) {
    if (!value)
        return '';
    if (fieldType === 'select') {
        if (options.length === 0) {
            return translate('errors.no_options_defined', { namespace: NAMESPACE });
        }
        if (!options.includes(value)) {
            return translate('errors.invalid_select_option', {
                namespace: NAMESPACE,
                value,
                options: options.join(', ')
            });
        }
    }
    else if (fieldType === 'multiselect') {
        if (options.length === 0) {
            return translate('errors.no_options_defined', { namespace: NAMESPACE });
        }
        const selectedValues = parseOptionsString(value);
        const invalidValues = selectedValues.filter((v) => !options.includes(v));
        if (invalidValues.length > 0) {
            return translate('errors.invalid_multiselect_options', {
                namespace: NAMESPACE,
                values: invalidValues.join(', '),
                options: options.join(', ')
            });
        }
    }
    return '';
}
/**
 * Validates all field definitions, checking for invalid default values
 * @param fields - Array of field definitions to validate
 * @returns Array of error messages (empty if all valid)
 */
export function validateFieldDefinitions(fields) {
    const errors = [];
    fields.forEach((field) => {
        if ((field.type === 'select' || field.type === 'multiselect') && field.default) {
            const defaultValue = Array.isArray(field.default) ? field.default.join(', ') : field.default.toString();
            const options = field.options || [];
            if (options.length === 0) {
                errors.push(`${translate('field', { namespace: NAMESPACE })} "${field.label}": ${translate('errors.no_options_defined', {
                    namespace: NAMESPACE
                })}`);
            }
            else if (field.type === 'select' && !options.includes(defaultValue)) {
                errors.push(`${translate('field', { namespace: NAMESPACE })} "${field.label}": ${translate('errors.invalid_select_option', {
                    namespace: NAMESPACE,
                    value: defaultValue,
                    options: options.join(', ')
                })}`);
            }
            else if (field.type === 'multiselect') {
                const selectedValues = parseOptionsString(defaultValue);
                const invalidValues = selectedValues.filter((v) => !options.includes(v));
                if (invalidValues.length > 0) {
                    errors.push(`${translate('field', { namespace: NAMESPACE })} "${field.label}": ${translate('errors.invalid_multiselect_options', {
                        namespace: NAMESPACE,
                        values: invalidValues.join(', '),
                        options: options.join(', ')
                    })}`);
                }
            }
        }
    });
    return errors;
}
